module.exports = __webpack_public_path__ + "static/img/Profit2.4452f28.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/Profit2.gif
// module id = /4sN
// module chunks = 56